import React from "react";
import logo from "../images/CRWDCombinationMark.png"

export default function WebsiteHeader() {
    return <div className="topNav">
        <a className="topNavLeft" href="/"><img src={logo} alt="Logo" /></a>
        <a className="downloadButton" href="https://apps.apple.com/us/app/crwd/id6444104160">Dowload</a>
    </div>
}